import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAZBn-bz1Sk8dbK7AYnwx02Q6A76Q0Ceak",
  authDomain: "lognow-controlo.firebaseapp.com",
  projectId: "lognow-controlo",
  storageBucket: "lognow-controlo.firebasestorage.app",
  messagingSenderId: "41207915465",
  appId: "1:41207915465:web:8db3b0a910d67be7697e18"
};

console.log("Storage Bucket Configuração:", firebaseConfig.storageBucket);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Set auth persistence
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Error setting auth persistence:", error);
});

// Enable Firestore offline persistence
enableIndexedDbPersistence(db).catch((error) => {
  if (error.code === 'failed-precondition') {
    console.warn('Firestore persistence failed - multiple tabs open');
  } else if (error.code === 'unimplemented') {
    console.warn('Firestore persistence not supported by browser');
  }
});

export default app;
